var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRequests = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.962 2.5H12a.5.5 0 0 1 0 1h-1c-1.428 0-2.45.001-3.225.105-.762.103-1.212.296-1.543.627s-.524.781-.627 1.543C5.501 6.55 5.5 7.572 5.5 9v6c0 1.428.001 2.45.105 3.225.103.762.296 1.212.627 1.543s.781.524 1.543.627c.776.104 1.797.105 3.225.105h2c1.428 0 2.45-.001 3.225-.105.762-.103 1.212-.296 1.543-.627s.524-.781.627-1.543c.104-.776.105-1.797.105-3.225v-2a.5.5 0 0 1 1 0v2.038c0 1.382 0 2.47-.114 3.32-.118.873-.363 1.57-.911 2.117-.548.548-1.244.793-2.117.91-.85.115-1.938.115-3.32.115h-2.076c-1.382 0-2.47 0-3.32-.114-.873-.118-1.57-.363-2.117-.911-.548-.548-.793-1.244-.91-2.117-.115-.85-.115-1.938-.115-3.32V8.962c0-1.382 0-2.47.114-3.32.118-.873.363-1.57.911-2.117.548-.548 1.244-.793 2.117-.91.85-.115 1.938-.115 3.32-.115",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.5 3a.5.5 0 0 0-1 0v2.5H15a.5.5 0 0 0 0 1h2.5V9a.5.5 0 0 0 1 0V6.5H21a.5.5 0 0 0 0-1h-2.5zM8.5 13a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M8.5 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M8.5 17a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRequests);
export default ForwardRef;